import React, { useEffect } from 'react';
import { Form, Formik, FormikValues } from 'formik';
import { useLanguageContext } from '@hooks/useLanguageContext';
import { useFetchAllLocationsWithoutPaginationQuery } from '@api/locations/locationsAPI';
import { SelectField } from '@components/Form/SelectField';
import { IOptions } from '@components/Select/types';
import { useScheduleContext } from '@pages/Schedule/context/useScheduleContext';
import './styles.scss';

interface ILegendProps {
  hideAppointments?: boolean;
}

export const Legend = ({ hideAppointments = false }: ILegendProps) => {
  const { dictionary } = useLanguageContext();

  const { data: locations } = useFetchAllLocationsWithoutPaginationQuery();

  const { selectedLocationId, setSelectedLocationId } = useScheduleContext();

  const locationOptions =
    locations?.data?.results.map(({ name: label, id: value }) => ({
      label,
      value,
    })) || [];

  const handleChange = (value: string | number) => {
    setSelectedLocationId(String(value));
    localStorage.setItem('locationSchedule', String(value));
  };

  const legendListDay = [
    {
      label: dictionary.schedule.table.minorClient,
      type: 'warning',
    },
    {
      label: dictionary.schedule.table.adultClient,
      type: 'primary',
    },
    {
      label: dictionary.schedule.table.unavailableTime,
      type: 'default',
    },
    {
      label: 'Blackout',
      type: 'danger-dark',
    },
  ];

  const legendListWeek = [
    {
      label: 'Appointments',
      type: 'appointment',
    },
    {
      label: 'Blackout',
      type: 'danger-dark',
    },
  ];

  const onSubmitForm = (formValues: FormikValues) => {
    // console.log(formValues);
  };

  const initialValues = {
    locationId: selectedLocationId || (locationOptions[0] ? locationOptions[0].value : ''),
  };

  useEffect(() => {
    const savedLocation = localStorage.getItem('locationSchedule');

    if (!selectedLocationId) {
      const defaultLocationId =
        savedLocation || (locationOptions.length > 0 ? String(locationOptions[0].value) : '');

      if (defaultLocationId) {
        setSelectedLocationId(defaultLocationId);
        localStorage.setItem('locationSchedule', defaultLocationId);
      }
    }
  }, [locations, selectedLocationId, setSelectedLocationId]);

  const filteredLegendList = hideAppointments ? legendListWeek : legendListDay;

  const title = hideAppointments ? 'History' : dictionary.schedule.table.appointment;

  return (
    <div className="legend">
      <div className="legend-container">
        <span className="legend-title">{`${title}: `}</span>
        <ul className="legend-list">
          {filteredLegendList?.map(({ label, type }, index) => (
            <li key={index} className={`legend-item is-${type}`}>
              <span className="legend-icon" />
              {label}
            </li>
          ))}
        </ul>
      </div>
      <div className="location">
        <Formik
          initialValues={initialValues}
          validationSchema={null}
          enableReinitialize
          onSubmit={onSubmitForm}
        >
          {() => (
            <Form className="form" noValidate>
              <SelectField
                selectOptions={locationOptions as IOptions[]}
                placeholder={dictionary.placeholders.chooseLocation}
                required
                name="locationId"
                getSelectedValue={handleChange}
              />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
